import { Component } from '@angular/core';
import { userTypesEnum } from 'src/app/common/constants/common.constants';
import { GlobalChecksTypesEnum } from 'src/app/common/constants/ProfileCheckTypes.const'; import { GlobalCheckTypes } from 'src/app/common/models/applicant.class';
import { CommonService } from 'src/app/common/services/common.service';
import { AdminService } from 'src/app/modules/admin/services/admin.service';

@Component({
  selector: 'app-internal-dashboard',
  templateUrl: './internal-dashboard.component.html',
  styleUrl: './internal-dashboard.component.scss'
})
export class InternalDashboardComponent {
  loggedInUserTypeId: number;
  userTypes = userTypesEnum;

  checks: any[] = [
    { checkTypeId: GlobalChecksTypesEnum.EDUCATION_DETAILS, checkName: 'Assigned Qualification Checks', url: "/#/check/education/" },
    // { checkTypeId: GlobalChecksTypesEnum.EMPLOYEE_DETAILS, checkName: 'Assigned Employment Checks', url: "/#/check/employement/" },
    //{ checkTypeId: GlobalChecksTypesEnum.ADDRESS_DETAILS, checkName: 'Assigned Address Details Checks', url: "/#/check/address/" },
    //{ checkTypeId: GlobalChecksTypesEnum.CREDIT_CHECK_CIBIL, checkName: 'Assigned Cibil Details Checks', url: "/#/check/credit/" },
    //{ checkTypeId: GlobalChecksTypesEnum.GLOBAL_DATABASE_CHECK, checkName: 'Assigned Global Database Checks', url: "/#/check/globaldatabase/" },
    //{ checkTypeId: GlobalChecksTypesEnum.REFERENCE_DETAILS, checkName: 'Assigned Reference Details Checks', url: "/#/check/reference/" },
    //{ checkTypeId: GlobalChecksTypesEnum.CRIMINAL_RECORDVERIFICATIONTHROUGHLAWFIRM, checkName: 'Assigned Criminal Records Checks', url: "/#/check/crv/" },
    //{ checkTypeId: GlobalChecksTypesEnum.DRUGTEST_9, checkName: 'Assigned Drug Details Checks', url: "/#/check/drug/" },
    //{ checkTypeId: GlobalChecksTypesEnum.POLICE_CRIMINAL_CHECK, checkName: 'Assigned Police Criminal Checks', url: "/#/check/police/" }
  ];


  statusCounts: any = {};
  constructor(
    private _adminService: AdminService,
    private _commonService: CommonService,
  ) {
  }

  ngOnInit() {
    this.loggedInUserTypeId = parseInt(this._commonService.getUserTypeId());
    if (this.loggedInUserTypeId != userTypesEnum.SUPER_ADMIN && this.loggedInUserTypeId != userTypesEnum.Manager) {
      this.fetchStatusCounts();
    }
  }
  fetchStatusCounts() {
    for (let check of this.checks) {
      const result = this._adminService.getChecksCount(check.checkTypeId).subscribe(
        res => {
          this.statusCounts[check.checkTypeId] = res;
        });
    }
  }
  navigateToProfileScreen(statusId, type) {
    const check = this.checks.find(c => c.checkTypeId === type);
    if (check) {
      window.open(window.location.origin + check.url + statusId);
    } else {
      console.log("Unknown check type");
    }
  }

  getTotalCount(checkId: number): number {
    const counts = this.statusCounts[checkId];
    return Array.isArray(counts) ? counts.reduce((sum, item) => sum + item.count, 0) : 0;
  }
}
